import _export from "../internals/export";
import _toObject from "../internals/to-object";
import _lengthOfArrayLike from "../internals/length-of-array-like";
import _toIntegerOrInfinity from "../internals/to-integer-or-infinity";
import _addToUnscopables from "../internals/add-to-unscopables";
var $ = _export;
var toObject = _toObject;
var lengthOfArrayLike = _lengthOfArrayLike;
var toIntegerOrInfinity = _toIntegerOrInfinity;
var addToUnscopables = _addToUnscopables;

// `Array.prototype.at` method
// https://tc39.es/ecma262/#sec-array.prototype.at
$({
  target: "Array",
  proto: true
}, {
  at: function at(index) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? undefined : O[k];
  }
});
addToUnscopables("at");
export default {};